import { Pipe, PipeTransform } from '@angular/core';
import { Constants } from 'src/app/shared/utils/constants';
@Pipe({ name: 'frequenciesPipe' })
export class FrequenciesPipe implements PipeTransform {
  transform(value: any): string {
    const obj = Constants.FREQUENCIES.find((x) => x.value === value);
    if (obj !== null) {
      return obj.text;
    }
  }
}
